/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Email } from './email';
import { LocationObject } from './locationObject';

export interface GeneralProfileData { 
    email?: Email;
    verified_email?: Email;
    phone_number?: string;
    location?: LocationObject;
    about?: string;
    zip_code?: string;
    created?: Date;
}